/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Display-only, provider-neutral airline fare and payment-fee evidence for the exact quote.
 * @export
 * @interface FlightCommercialQuoteEvidence
 */
export interface FlightCommercialQuoteEvidence {
  /**
   *
   * @type {string}
   * @memberof FlightCommercialQuoteEvidence
   */
  schemaVersion: FlightCommercialQuoteEvidenceSchemaVersionEnum;
  /**
   *
   * @type {number}
   * @memberof FlightCommercialQuoteEvidence
   */
  baseFare: number;
  /**
   *
   * @type {number}
   * @memberof FlightCommercialQuoteEvidence
   */
  taxes: number;
  /**
   *
   * @type {number}
   * @memberof FlightCommercialQuoteEvidence
   */
  aggregateFees: number;
  /**
   *
   * @type {string}
   * @memberof FlightCommercialQuoteEvidence
   */
  airlinePaymentFeeStatus: FlightCommercialQuoteEvidenceAirlinePaymentFeeStatusEnum;
  /**
   *
   * @type {number}
   * @memberof FlightCommercialQuoteEvidence
   */
  airlinePaymentFee: number | null;
  /**
   *
   * @type {number}
   * @memberof FlightCommercialQuoteEvidence
   */
  total: number;
  /**
   *
   * @type {string}
   * @memberof FlightCommercialQuoteEvidence
   */
  currency: string;
}

/**
 * @export
 */
export const FlightCommercialQuoteEvidenceSchemaVersionEnum = {
  FlightQuoteCommercialEvidenceV1: "flight-quote-commercial-evidence-v1",
} as const;
export type FlightCommercialQuoteEvidenceSchemaVersionEnum =
  (typeof FlightCommercialQuoteEvidenceSchemaVersionEnum)[keyof typeof FlightCommercialQuoteEvidenceSchemaVersionEnum];

/**
 * @export
 */
export const FlightCommercialQuoteEvidenceAirlinePaymentFeeStatusEnum = {
  Quoted: "quoted",
  Unknown: "unknown",
} as const;
export type FlightCommercialQuoteEvidenceAirlinePaymentFeeStatusEnum =
  (typeof FlightCommercialQuoteEvidenceAirlinePaymentFeeStatusEnum)[keyof typeof FlightCommercialQuoteEvidenceAirlinePaymentFeeStatusEnum];

/**
 * Check if a given object implements the FlightCommercialQuoteEvidence interface.
 */
export function instanceOfFlightCommercialQuoteEvidence(
  value: object
): value is FlightCommercialQuoteEvidence {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("baseFare" in value) || value["baseFare"] === undefined) return false;
  if (!("taxes" in value) || value["taxes"] === undefined) return false;
  if (!("aggregateFees" in value) || value["aggregateFees"] === undefined)
    return false;
  if (
    !("airlinePaymentFeeStatus" in value) ||
    value["airlinePaymentFeeStatus"] === undefined
  )
    return false;
  if (
    !("airlinePaymentFee" in value) ||
    value["airlinePaymentFee"] === undefined
  )
    return false;
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  return true;
}

export function FlightCommercialQuoteEvidenceFromJSON(
  json: any
): FlightCommercialQuoteEvidence {
  return FlightCommercialQuoteEvidenceFromJSONTyped(json, false);
}

export function FlightCommercialQuoteEvidenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightCommercialQuoteEvidence {
  if (json == null) {
    return json;
  }
  return {
    schemaVersion: json["schema_version"],
    baseFare: json["base_fare"],
    taxes: json["taxes"],
    aggregateFees: json["aggregate_fees"],
    airlinePaymentFeeStatus: json["airline_payment_fee_status"],
    airlinePaymentFee: json["airline_payment_fee"],
    total: json["total"],
    currency: json["currency"],
  };
}

export function FlightCommercialQuoteEvidenceToJSON(
  json: any
): FlightCommercialQuoteEvidence {
  return FlightCommercialQuoteEvidenceToJSONTyped(json, false);
}

export function FlightCommercialQuoteEvidenceToJSONTyped(
  value?: FlightCommercialQuoteEvidence | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    schema_version: value["schemaVersion"],
    base_fare: value["baseFare"],
    taxes: value["taxes"],
    aggregate_fees: value["aggregateFees"],
    airline_payment_fee_status: value["airlinePaymentFeeStatus"],
    airline_payment_fee: value["airlinePaymentFee"],
    total: value["total"],
    currency: value["currency"],
  };
}
